/**
 * @file
 * Custom JS behaviour for product.
 */

(function ($) {

  Drupal.behaviors.languageMenu = {
    attach: function (context, settings) {
      // Language label.
      var langCode = drupalSettings.path.currentLanguage;
      $('#block-language > ul > li > span').text(langCode);
    }
  };

})(jQuery);
